import React, { useState } from 'react';
import MuscleMap from '../MuscleMap/MuscleMap';

/*
 * Escolher os músculos de um exercício no modelo anatómico: o clique significa "principal" ou
 * "secundário" consoante o modo escolhido; um músculo está num papel de cada vez (clicar num que está
 * no outro papel passa-o para o actual). Os ids são os canónicos do MuscleMap.
 */

export default function MusclePicker({ muscles, primary, secondary, onChange, disabled = false }) {
  const [view, setView] = useState('front');
  const [role, setRole] = useState('primary');

  const byId = Object.fromEntries((muscles || []).map((m) => [m.id, m]));
  const nameOf = (id) => byId[id]?.name || id;

  const toggle = ({ muscleId }) => {
    if (disabled) return;
    const inPrimary = primary.includes(muscleId);
    const inSecondary = secondary.includes(muscleId);

    if (role === 'primary') {
      if (inPrimary) onChange({ primary: primary.filter((m) => m !== muscleId), secondary });
      else onChange({ primary: [...primary, muscleId], secondary: secondary.filter((m) => m !== muscleId) });
    } else if (inSecondary) {
      onChange({ primary, secondary: secondary.filter((m) => m !== muscleId) });
    } else {
      onChange({ primary: primary.filter((m) => m !== muscleId), secondary: [...secondary, muscleId] });
    }
  };

  const remove = (id) => onChange({ primary: primary.filter((m) => m !== id), secondary: secondary.filter((m) => m !== id) });

  return (
    <div className="lib-muscles">
      <div>
        <div className="lib-muscle-mode" role="tablist" aria-label="Vista do corpo">
          <button type="button" role="tab" className="lib-section-btn" aria-selected={view === 'front'} onClick={() => setView('front')}>Frente</button>
          <button type="button" role="tab" className="lib-section-btn" aria-selected={view === 'back'} onClick={() => setView('back')}>Costas</button>
        </div>
        <div className="lib-mapbox">
          <MuscleMap view={view} selectedMuscleIds={primary} secondaryMuscleIds={secondary} onMuscleToggle={toggle} height={380} />
        </div>
        <div className="lib-legend" aria-hidden="true">
          <span><i style={{ background: '#ef4444' }} />Principal</span>
          <span><i style={{ background: '#fdba74' }} />Secundário</span>
        </div>
      </div>

      <div>
        <div className="lib-field">
          <span className="lib-label">O que o clique faz</span>
          <div className="lib-muscle-mode" role="radiogroup" aria-label="Papel do músculo escolhido">
            <button type="button" role="radio" className="lib-section-btn" aria-checked={role === 'primary'} aria-selected={role === 'primary'}
              onClick={() => setRole('primary')}>Músculo principal</button>
            <button type="button" role="radio" className="lib-section-btn" aria-checked={role === 'secondary'} aria-selected={role === 'secondary'}
              onClick={() => setRole('secondary')}>Músculo secundário</button>
          </div>
          <span className="lib-hint">Clique no corpo para acrescentar ou retirar. Um exercício precisa de pelo menos um músculo principal.</span>
        </div>

        <div className="lib-field">
          <span className="lib-label">Principais</span>
          <div className="lib-chips">
            {primary.length === 0 && <span className="lib-hint">Nenhum escolhido</span>}
            {primary.map((id) => (
              <span key={id} className="lib-chip bad">{nameOf(id)}
                {!disabled && <button type="button" aria-label={`Retirar ${nameOf(id)}`} onClick={() => remove(id)}>×</button>}
              </span>
            ))}
          </div>
        </div>

        <div className="lib-field">
          <span className="lib-label">Secundários</span>
          <div className="lib-chips">
            {secondary.length === 0 && <span className="lib-hint">Nenhum escolhido</span>}
            {secondary.map((id) => (
              <span key={id} className="lib-chip warn">{nameOf(id)}
                {!disabled && <button type="button" aria-label={`Retirar ${nameOf(id)}`} onClick={() => remove(id)}>×</button>}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
